import * as t from 'io-ts';
import _ from 'lodash';

import {getCardNoteDisplayDate} from '../../helpers/models/cardNoteHelpers';
import {makeApiType} from './apiTypes';
import {parseCard, RCard} from './cardModel';
import {parseCardNote, RCardNote} from './cardNoteModel';

/*
 * Runtime type.
 */

const RPreviewCardMergeDirty = t.readonly(
  t.type({
    card: RCard,
    notes: t.readonlyArray(RCardNote),
  }),
);

/*
 * Type.
 */

export interface PreviewCardMergeModel extends t.TypeOf<typeof RPreviewCardMergeDirty> {}
export const RPreviewCardMerge = t.clean<PreviewCardMergeModel>(RPreviewCardMergeDirty as any);

/*
 * IO methods.
 */

function parsePreviewCardMerge(src: any): PreviewCardMergeModel {
  // Sort the notes in desending order
  const notes = _(src.notes && src.notes.map((note: any) => parseCardNote(note)))
    .sort((a, b) => getCardNoteDisplayDate(b) - getCardNoteDisplayDate(a))
    .value();
  return {
    card: src.card && parseCard(src.card),
    notes,
  };
}

/*
 * API type.
 */

export const ApiPreviewCardMerge = makeApiType('PreviewCardMerge', RPreviewCardMerge, parsePreviewCardMerge);
